module.exports = __webpack_public_path__ + "static/super-secure-64921f2a45aafbb26ac799f4f102f083.gif";